
    import './styles.scoped.css';
    export default {
  "drawer": "awsui_drawer_1r9lg_1sutq_197",
  "refresh": "awsui_refresh_1r9lg_1sutq_197",
  "animating": "awsui_animating_1r9lg_1sutq_211",
  "drawer-closed": "awsui_drawer-closed_1r9lg_1sutq_266",
  "drawer-content-side": "awsui_drawer-content-side_1r9lg_1sutq_271",
  "drawer-content-bottom": "awsui_drawer-content-bottom_1r9lg_1sutq_287",
  "position-bottom": "awsui_position-bottom_1r9lg_1sutq_294",
  "position-side": "awsui_position-side_1r9lg_1sutq_321",
  "slider-wrapper-bottom": "awsui_slider-wrapper-bottom_1r9lg_1sutq_327",
  "slider-wrapper-side": "awsui_slider-wrapper-side_1r9lg_1sutq_338",
  "open-button-side": "awsui_open-button-side_1r9lg_1sutq_349",
  "pane-header-wrapper-bottom": "awsui_pane-header-wrapper-bottom_1r9lg_1sutq_358",
  "drawer-mobile": "awsui_drawer-mobile_1r9lg_1sutq_368",
  "drawer-disable-content-paddings": "awsui_drawer-disable-content-paddings_1r9lg_1sutq_372",
  "content-bottom": "awsui_content-bottom_1r9lg_1sutq_381",
  "pane-bottom-center-align": "awsui_pane-bottom-center-align_1r9lg_1sutq_397",
  "pane-bottom-content-nav-padding": "awsui_pane-bottom-content-nav-padding_1r9lg_1sutq_402",
  "pane-bottom-content-tools-padding": "awsui_pane-bottom-content-tools-padding_1r9lg_1sutq_406",
  "content-bottom-max-width": "awsui_content-bottom-max-width_1r9lg_1sutq_410",
  "content-side": "awsui_content-side_1r9lg_1sutq_415",
  "pane-header-wrapper-side": "awsui_pane-header-wrapper-side_1r9lg_1sutq_425",
  "pane-content-wrapper-side": "awsui_pane-content-wrapper-side_1r9lg_1sutq_431",
  "header": "awsui_header_1r9lg_1sutq_439",
  "header-text": "awsui_header-text_1r9lg_1sutq_449",
  "header-actions": "awsui_header-actions_1r9lg_1sutq_462",
  "divider": "awsui_divider_1r9lg_1sutq_470"
};
  